import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/images/log2.png'
import _imports_1 from '../assets/images/pc/thr2.png'


const _hoisted_1 = { class: "header-boxs" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = { class: "menuChild" }

import {onMounted, ref, watch} from "vue";
import { useStore } from 'vuex';
import { useRouter,useRoute } from "vue-router"
import { SHOW_DIGITAL_GAME } from '@/views/home/visibility'

export default /*@__PURE__*/_defineComponent({
  __name: 'CCHeader',
  emits: ['clickMenu', 'clickChildMenu'],
  setup(__props, { emit: __emit }) {

const store = useStore();
const router = useRouter()
const route = useRoute()
const emit = __emit

const path = ref('')
watch(() => route.path, (newVal) => {
 path.value = newVal
})
const OnEnter = (event) => {
  if (event.target.children.length === 1) {
    event.target.children[0].classList.remove('normal')
    event.target.children[0].classList.add('highlight')
  }
  event.target.classList.add('hover')
  event.target.classList.add('active')
}

const OnLeave = (event) => {
  if (event.target.children.length === 1) {
    event.target.children[0].classList.remove('highlight')
    event.target.children[0].classList.add('normal')
  }
  event.target.classList.remove('hover')
  event.target.classList.remove('active')
}

const OnClick = (event, id, navIndex = 0) => {
  if(router.currentRoute.value.fullPath == '/'){
    // 首页直接跳转到锚点
    emit('clickMenu', id)
  }else {
    // 其他页面跳转到首页再定位锚点
    router.replace({
      path: '/home'
    })
    setTimeout(() => {
      emit('clickMenu', id)
    }, 400)
  }
  store.commit('setProductIndex', Number(navIndex))

}

const JumpPage = (path: string) => {
  router.replace({
    path
  })
}
const openUrl = () => {
  window.open('https://www.walmart.com/global/seller/102762736/cp/shopall?povid=LFNav_Landing%20Page_sellerpage_cat_pill_shopall', '_blank')
}
const OnClickChild = (event, uri) => {
  emit('clickChildMenu', uri)
}

const splitPath = () => {
  // console.log('window.location.pathname =====>' + window.location.pathname);
  // console.log('window.location.search =====>' + window.location.search);
  return window.location.pathname.split('/');
}

const isRootPage = (sp: string[]): boolean => {
  return sp.length > 2 ? false : true;
}

let level = splitPath();
let isRoot = isRootPage(level);
level[0] = '.';
// console.log('level:' + level + ',isRoot:' + isRoot)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "left" }, null, -1)),
      _createElementVNode("div", {
        class: "middle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (OnClick($event, 1)))
      }, [...(_cache[9] || (_cache[9] = [
        _createElementVNode("img", {
          src: _imports_0,
          class: "logo",
          alt: ""
        }, null, -1)
      ]))]),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "right" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          onMouseenter: OnEnter,
          onMouseleave: OnLeave,
          class: _normalizeClass(path.value == '/home' ? 'show' : '')
        }, [
          _createElementVNode("div", {
            class: "menuBox",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (JumpPage('/home')))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("h1", { class: "normal" }, "Home", -1),
            _createElementVNode("img", {
              src: _imports_1,
              alt: "",
              class: "arrow"
            }, null, -1)
          ]))]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (OnClick($event, 1, 1)), ["stop"]))
              }, "Board Games"),
              _createElementVNode("li", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (OnClick($event, 2, 2)), ["stop"]))
              }, "Crowdfunding Game"),
              (_unref(SHOW_DIGITAL_GAME))
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (OnClick($event, 3, 3)), ["stop"]))
                  }, "Digital Games"))
                : _createCommentVNode("", true)
            ])
          ])
        ], 34),
        _createElementVNode("div", {
          onMouseenter: OnEnter,
          onMouseleave: OnLeave,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (JumpPage('/team'))),
          class: _normalizeClass(path.value == '/team' ? 'show' : '')
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("h1", { class: "normal" }, "Team", -1)
        ]))], 34),
        _createElementVNode("div", {
          onMouseenter: OnEnter,
          onMouseleave: OnLeave,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (JumpPage('/news'))),
          class: _normalizeClass(path.value == '/news' ? 'show' : '')
        }, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("h1", { class: "normal" }, "News", -1)
        ]))], 34),
        _createElementVNode("div", {
          onMouseenter: OnEnter,
          onMouseleave: OnLeave,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (openUrl()))
        }, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("h1", { class: "normal" }, "Shop", -1)
        ]))], 32),
        _createElementVNode("div", {
          onMouseenter: OnEnter,
          onMouseleave: OnLeave,
          onClick: _cache[8] || (_cache[8] = ($event: any) => (JumpPage('/contact'))),
          class: _normalizeClass(path.value == '/contact' ? 'show' : '')
        }, [...(_cache[16] || (_cache[16] = [
          _createElementVNode("h1", { class: "normal" }, "Contact", -1)
        ]))], 34)
      ])
    ])
  ]))
}
}

})